import React from 'react';
import { Div } from './styles';

const Textarea = ({
    label, 
    name, 
    extraInformation, 
    value, 
    onChange, 
    onFocus, 
    onBlur, 
    active,
    type,
    validName,
    className,
    onKeyDown
}) => {
    const ref = React.useRef(null);

    function focusInput(){
        ref.current.focus();
    }

    return (
        <Div activeItem={active} className={className}> 
            <label
                onClick={focusInput} 
                htmlFor={name}
            >{label}</label>

            <textarea 
                onFocus={onFocus}
                onBlur={onBlur} 
                onChange={onChange}
                type={type} 
                name={name} 
                ref={ref}
                value={value}
                className={`${validName}`}
                onKeyDown={onKeyDown}
            ></textarea>
            
            <ul className="errors"></ul>
            {extraInformation && <ul className="extra-inf">{extraInformation}</ul>}
        </Div>
    )
}

export default Textarea
